// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AppPaletteEnum {
  export enum Figure {
    Point = 'point',
    Direction = 'direction', // 방향을 나타내는 화살표 도형
    Brush = 'brush',
    Circle = 'circle',
    Rectangle = 'rectangle',
    Rectangle_Stripe = 'rectangle_stripe',
    Circle_Stripe = 'circle_stripe',
    Line = 'line',
    Arrow = 'arrow',
    DoubleArrow = 'doubleArrow',
    Room = 'room',
    Wall = 'wall',
    Wall_Corner = 'wall_corner',
    Wall_U = 'wall_u',
    Door = 'door',
    Window = 'window',
    Stair = 'stair',
    Elevator = 'elevator',
  }

  export const ShapeString: { [key in Figure]: string } = {
    [Figure.Point]: '점',
    [Figure.Direction]: '방향',
    [Figure.Brush]: '그리기',
    [Figure.Circle]: '원',
    [Figure.Rectangle]: '영역',
    [Figure.Rectangle_Stripe]: '사각형(빗금)',
    [Figure.Circle_Stripe]: '원(빗금)',
    [Figure.Line]: '직선',
    [Figure.Arrow]: '화살표',
    [Figure.DoubleArrow]: '양방향 화살표',
    [Figure.Room]: '방',
    [Figure.Wall]: '벽',
    [Figure.Wall_Corner]: '코너',
    [Figure.Wall_U]: '벽(U)',
    [Figure.Door]: '문',
    [Figure.Window]: '창',
    [Figure.Stair]: '계단',
    [Figure.Elevator]: '엘리베이터',
  }

  // 그리기 도구 PC 키보드 단축키 (표시되는 도구만 정의)
  export const ShapeShortcut: Partial<{ [key in Figure]: string }> = {
    [Figure.Point]: 'P',
    [Figure.Direction]: 'D',
    [Figure.Rectangle]: 'R',
    [Figure.Brush]: 'B',
  }
}
